exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.not-found-page .full-page > .content,\n.not-found-page .centered {\n  min-height: calc(100vh - 160px);\n}\n.not-found-page .not-found-icon {\n  margin-right: 10px;\n}\n.not-found-page .centered {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-bottom: 150px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  color: white;\n}\n.not-found-page .centered h1, .not-found-page .centered i {\n    font-size: 50px;\n}\n.not-found-page .centered p {\n    font-size: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5745e353","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/GeneralViews/NotFoundPage.vue
// module id = 0FvH
// module chunks = 4